import { Component, inject } from "@angular/core";
import { EventsService } from "../../services/events.service";
import { CommonModule } from "@angular/common";
import { NgOptimizedImage } from "@angular/common";

@Component({
    imports: [CommonModule, NgOptimizedImage],
    selector: "app-spinner",
    templateUrl: "./spinner.component.html",
    styleUrls: ["./spinner.component.scss"]
})
export class SpinnerComponent {  eventsService = inject(EventsService);

}
